/**
 * Google Workspace utilities.
 *
 * Maps user email domains to the BARK-managed G Suite accounts used for
 * domain-wide delegation.  Must stay in sync with the backend mapping in
 * orchestrator.py (_DELEGATED_USER_DOMAIN_MAP).
 */

const DELEGATED_USER_DOMAIN_MAP: Record<string, string> = {
  'nordax.se': 'noba@barktechnologies.se',
  'norionbank.se': 'norion@barktechnologies.se',
  'norion.se': 'norion@barktechnologies.se',
};

/**
 * Given a user's login email, return the Google Workspace email they should
 * be signed into in order to view embedded Google Sheets / Docs.
 *
 * - Customer domains are mapped to shared BARK G Suite accounts.
 * - BARK users (@barktechnologies.se) pass through as-is.
 * - Unknown domains return the original email.
 */
export function getGoogleWorkspaceEmail(userEmail: string): string {
  const domain = userEmail.split('@').pop()?.toLowerCase() ?? '';
  return DELEGATED_USER_DOMAIN_MAP[domain] ?? userEmail;
}
